export const HAS_REFRESH_TOKEN_COOKIE = 'mnpg_has_refresh_token'

export const IS_AUTHENTICATED_COOKIE = 'mnpg_is_authenticated'

export const SESSION_ID = 'mnpg_session_id'

export const LAST_LOGIN_COOKIE = 'mnpg_last_login_data'
